import { IEntity } from '@pf/shared-common';
import {
    EquipmentTypeFragment,
    ResourceAuth,
    WarehouseItemSettingsSearchRequestParams,
    WarehouseItemSettingsViewModelCreateBody,
    WarehouseItemSettingsViewModelRead,
} from '@control-tower/platform-wms';
import { ICustomFieldDto } from '@pf/shared/util-platform';

export type WarehouseItemSettingRead = WarehouseItemSettingsViewModelRead &
    IEntity;

export type WarehouseItemSettingCreate =
    WarehouseItemSettingsViewModelCreateBody;

export type WarehouseItemSettingSearchParams =
    WarehouseItemSettingsSearchRequestParams;

export class WarehouseItemSettingDto implements IEntity {
    constructor(data: Partial<WarehouseItemSettingDto>) {
        Object.assign(this, data);
    }

    id!: string;
    itemId!: string;
    warehouseId!: string;
    primaryMinQuantity?: number | null;
    primaryMaxQuantity?: number | null;
    secondaryMinQuantity?: number | null;
    secondaryMaxQuantity?: number | null;
    totalWarehouseMin?: number | null;
    totalWarehouseMax?: number | null;
    criticalMin?: number | null;
    leadTimeDays?: number | null;
    safetyStockQuantity?: number | null;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    customFields?: ICustomFieldDto[] | null;
    resourceAuth?: ResourceAuth;
    equipmentType?: EquipmentTypeFragment | null;
}
